import React from "react";
import { useLocation } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Typography,
} from "@material-ui/core";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4, 2),
  },
  content: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  spaceAfter: {
    marginBottom: 15,
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));

// Shown instead of EmailInUse's dead end when the backend can actually
// offer a way back in - see UserSocialAccountAdapter.pre_social_login
// (song_proposals/adapters.py), code "verify_to_link". Clicking the
// emailed link (SocialLinkConfirm, api/views.py) lands back on /login
// with a real, sign-in-able account - this page is just the "we sent
// it, go check" moment in between.
export const VerifyToLink = () => {
  const classes = useStyles();
  const location = useLocation();
  const email = location.state && location.state.email;

  return (
    <Box className={classes.root} component="main">
      <CssBaseline />
      <Container maxWidth="xs">
        <div className={classes.content}>
          <Avatar className={classes.avatar}>
            <MailOutlineIcon />
          </Avatar>
          <Typography component="h1" variant="h5" className={classes.spaceAfter}>
            Check your email
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {email
              ? `An account for ${email} already exists on PlanPraise.`
              : "An account with this email already exists on PlanPraise."}
          </Typography>
          <Typography variant="body1" color="textSecondary" className={classes.spaceAfter}>
            We've sent a confirmation link to that email - click it to connect
            this sign-in method, then come back and sign in again.
          </Typography>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            href="/login"
          >
            Back to sign in
          </Button>
        </div>
      </Container>
    </Box>
  );
};

export default VerifyToLink;
